import moment from 'moment-timezone';

const DEFAULT_FORMAT = 'DD MMM YYYY';
const DATE_TIME_FORMAT = 'DD MMM YYYY, h:mm A';

export const formatDate = (date: string, format: string = DEFAULT_FORMAT, timezone?: string): string => {
  if (!date) return '—';
  const m = timezone ? moment(date).tz(timezone) : moment(date);
  return m.isValid() ? m.format(format) : '—';
};

export const formatDateTime = (date: string, timezone?: string): string => {
  return formatDate(date, DATE_TIME_FORMAT, timezone);
};

export const formatDateRange = (startDate: string, endDate: string, timezone?: string): string => {
  if (!startDate || !endDate) return '—';

  const start = timezone ? moment(startDate).tz(timezone) : moment(startDate);
  const end = timezone ? moment(endDate).tz(timezone) : moment(endDate);

  if (!start.isValid() || !end.isValid()) return '—';

  // Same year: collapse year on start date
  if (start.year() === end.year()) {
    if (start.month() === end.month() && start.date() === end.date()) {
      return start.format(DEFAULT_FORMAT);
    }
    return `${start.format('DD MMM')} – ${end.format(DEFAULT_FORMAT)}`;
  }

  return `${start.format(DEFAULT_FORMAT)} – ${end.format(DEFAULT_FORMAT)}`;
};

export const formatRelativeTime = (date: string): string => {
  if (!date) return '—';
  const m = moment(date);
  return m.isValid() ? m.fromNow() : '—';
};
